<template>
  <DialogTemplateToolkit
    class-name="filters-template-dialog"
    data-qa="filters-template-dialog"
    :dialog="dialog"
    first_btn="Common.Save"
    :loading="loading"
    :title="item ? $t('Common.Filters.EditSavedTemplate') : $t('Common.Filters.SaveFilterAsTemplate')"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <div
        v-if="item"
        class="flex"
        :class="className"
        data-qa="filters-template-actions">
        <sButton
          data-qa="btn-edit-filter"
          :disabled="loading"
          icon="edit"
          small
          type="text"
          @click.stop="open"/>
        <sButton
          v-if="!only_edit"
          data-qa="btn-delete-filter"
          :disabled="loading"
          icon="delete"
          small
          type="text"
          @click.stop="deleteTemplate"/>
      </div>
      <MenuItem
        v-else
        data-qa="btn-add-filter-template"
        icon="file-add"
        :label="$t('Common.SaveAsTemplate')"
        small
        @click="open"/>
    </template>
    <template #card-text>
      <div
        class="filters-template-dialog__items"
        data-qa="filters-template-filters">
        <FilterRow
          v-for="(filter, n) in template_filters"
          :key="filter.id"
          class="pb-3"
          disabled
          :elem="filter"
          :items="[filter]"
          :mode.sync="template_mode"
          :num="n"
          with-mode>
          <template #activator>
            <slot
              :disabled="true"
              :item="filter"
              name="item"/>
          </template>
        </FilterRow>
      </div>

      <sForm
        ref="filtersTemplateForm"
        class="filters-template-dialog__settings"
        :disabled="loading"
        label-position="top"
        label-width="0px"
        :model="{name}"
        :rules="rules">
        <sFormItem
          :label="$t('Common.Filters.TemplateName')"
          prop="name">
          <sInput
            data-qa="filters-template-name-input"
            max-length="50"
            show-word-limit
            :value.sync="name"/>
        </sFormItem>
        <sCheckbox
          v-model="isDefault"
          data-qa="filters-template-isDefault"
          :disabled="loading">
          {{ $t('Common.Filters.AddAsDefaultFilterWillBeAppliedToEachLogin') }}
        </sCheckbox>
        <sCheckbox
          v-if="filters_type != 'PLANS'"
          v-model="isPinned"
          data-qa="filters-template-isPinned"
          :disabled="isDefault || loading">
          <span :class="{'disabled': isDefault}">
            {{ $t('Common.Filters.PinSavedFilterToQuickFiltersPanel') }}
          </span>
        </sCheckbox>
      </sForm>
    </template>
    <template
      #in-footer>
      <sButton
        v-if="item"
        class="ml-auto px-2"
        data-qa="btn-deleteTemplate"
        :disabled="loading"
        icon="delete"
        type="text"
        @click="deleteTemplate">
        {{ $t('Common.Filters.DeleteTemplate') }}
      </sButton>
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import FilterRow from 'components/common/elements/FilterRow.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { storageMixin, filtersTemplatesMixin } from 'mixins'
import { eventBus } from '@/main'

export default {
  name: 'filtersTemplateDialog',
  mixins: [storageMixin, filtersTemplatesMixin],
  data() {
    const that = this
    return {
      name: '',
      dialog: false,
      loading: false,
      rules: {
        name: [
          {
            required: true,
            type: 'string',
            trigger: 'change',
            max: 50,
            message: this.$t('Validate.maxLength', {number: 50, type: this.$tc('Common.characters', 50) })
          },
          {
            type: 'string',
            trigger: 'change',
            transform(value) {
              return value.trim()
            },
            validator(rule, value, callback) {
              if (!value) {
                callback(new Error(that.$t('Validate.Required')))
              }
              if (that.filters_templates.some(el => el.filterName == value && that.item?.id != el.id)) {
                callback(new Error(that.$t('Tenders.TheTemplateNameMustBeUnique')))
              }
              callback()
            },
          }
        ],
      },
      isPinned: false,
      isDefault: false,
      template_filters: [],
      template_mode: false
    }
  },
  props: {
    /**
     * вже збережений шаблон - для редагування
     */
    item: {
      type: Object,
    },
    /**
     * фільтри - для збереження
     */
    filters: {
      type: Array
    },
    mode: Boolean,
    /**
     * тільки редагування - для готового аблону прибрати кнопку видалення (для закрепленных фильтров)
     */
    only_edit: Boolean,
    /**
     * клас дя активатора
     */
    className: String,
    addTemplate: Function,
    editTemplate: Function,
    deleteFilterTemplate: Function
  },
  computed: {
    filters_templates() {
      if ( this.filters_type ) {
        let filters_templates = this.$store.getters.getFiltersTemplatesByType || {}
        return  filters_templates[this.filters_type] || []
      }
      return []
    },
  },
  methods: {
    open() {
      if (this.item) {
        let template = JSON.parse(this.item.filterJson)
        this.template_mode = template.mode
        this.template_filters = template.filters
        this.name = this.item.filterName
        this.isDefault = this.item.isDefault
        this.isPinned = this.item.isPinned
      } else {
        this.template_mode = this.mode
        this.template_filters = this.getFilters(this.filters).filters
      }
      setTimeout(() => {
        this.dialog = true
      }, 100)
    },
    close() {
      this.$refs.filtersTemplateForm.clearValidate()
      this.dialog = false
    },
    async apply() {
      await this.$refs.filtersTemplateForm.validate()
      this.loading = true
      let filterJson = JSON.stringify( {
          filters: this.template_filters,
          mode: this.template_mode
        } ),
        checkDefault = item => {
          if ( this.isDefault && item) {
            let is_default = this.filters_templates.find(templ => templ.isDefault && templ.id != item.id)
            if ( is_default ) {
              is_default.isDefault = false
              this.$store.commit('editFiltersTemplate', is_default)
            }
          }
        }
      if ( this.filters ) {
        await this.$store.dispatch('addFilterTemplates', {
          id: 0,
          isDefault: this.isDefault,
          isPinned: this.isPinned,
          filterJson,
          filterName: this.name,
          filterType: this.filters_type,
        }).then(res => {
          res.filterObject = filterJson ? JSON.parse(filterJson) : {}
          this.addTemplate(res)
          checkDefault(res)
          this.$nextTick(() => {
            this.showFilterTemplateTour(res)
          })
        })

      } else if (this.item) {
        let peyload = {
          id: this.item.id,
          isDefault: this.isDefault,
          isPinned: this.isPinned,
          filterName: this.name,
          filterType: this.filters_type
          // filterType: this.filters_type, // QUASTION точно не треба ?
        }
        await this.$store.dispatch('editFilterTemplate', peyload).then(res => {
          if ( res ) {
            this.$root.$emit('updateFilters', {
              change_template: peyload
            })
            checkDefault(this.item)

            this.$nextTick(() => {
              this.showFilterTemplateTour(this.item)
            })
          }
        })
      }

      this.loading = false
    },
    async deleteTemplate() {
      this.loading = true
      await this.$store.dispatch('deleteFilterTemplate', {id: this.item?.id, type: this.filters_type }).then(res => {

        eventBus.$emit('deleteFilterTemplate', this.item )
        if ( res && this.deleteFilterTemplate) {
          this.deleteFilterTemplate(this.item?.id)
        }
      })
      this.loading = false
      this.dialog = false
    },
    async showFilterTemplateTour(item) {
      await this.$_getPropFromDBStorage('filters-template_tour', false)
        .then(async (viewedTour) => {
          const has_pinned_filters = this.filters_templates.filter(el => el.isPinned && el.id !== item.id)?.length
          if (viewedTour || !has_pinned_filters || !this.isPinned) { return }

          const tour = [
            {
              dataKey: 'pinned-filters-templates',
              title: this.$t('Common.FilterTemplatesTitleTour'),
              text: this.$t('Common.FilterTemplatesTour'),
              step: 1,
              position: 'middle-right'
            }
          ]
          eventBus.$emit('startTour', tour)
          await this.$_savePropToDBStorage('filters-template_tour', true, new Date().setDate(new Date().getDate() + 180))
        })
        .finally(() => {
          this.dialog = false
        })
    }
  },
  watch: {
    isDefault(val) {
      if ( val ) {
        this.isPinned = true
      }
    }
  },
  components: {
    MenuItem,
    FilterRow,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.filters-template-dialog {
  &__items {
    position: relative;
    padding: 8px 16px 16px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;

      background: var(--black-color);
      opacity: 0.1;
      border-radius: 8px;
    }
  }
  &__settings {
    padding: 8px;
  }
}
.disabled {
  color: var(--black-color);
  //opacity: 0.3;
}
</style>
